import DOMPurify from "dompurify";

// GenelYardimSayfasi.vue ve (varsa) HelperLayout/YardimPaneli.vue aynı yardım
// içeriğini v-html ile basar; ikisi de bu tek noktadan geçmeli (bkz.
// Dokumanlar/Arayuz/YARDIM-SAYFALARI-PLANI.md §4.3).
export function sanitizeYardimIcerik(html) {
  return DOMPurify.sanitize(html || "");
}
